<template>
  <Layout>
    <PageHeader :items="items" :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <table class="table">
                  <thead>
                  <tr><th>Sale Number:</th> <td><span class="text-primary">{{ SaleDetail.code }}</span></td></tr>
                  <tr><th>Sale Total:</th> <td><span class="text-primary">{{ thousandSeparator(SaleDetail.totalAmount) }}/=</span></td></tr>
                  <tr><th>Total Paid:</th> <td><span class="text-primary">{{ thousandSeparator(SaleDetail.amountPaid) }}/=</span></td></tr>
                  </thead>
                </table>
              </div>
              <div class="col-md-6">
                <table class="table">
                  <thead>
                  <tr><th>Sale Balance:</th> <td><span class="text-primary">{{ thousandSeparator(SaleDetail.balance) }}/=</span></td></tr>
                  <tr><th>Client:</th> <td><span class="text-primary">{{ SaleDetail.customer }}</span></td></tr>
                  <tr><th>Served By:</th> <td><span class="text-primary">{{ SaleDetail.addedBy.name }} ({{ SaleDetail.addedBy.email }})</span></td></tr>
                  </thead>
                </table>
              </div>
            </div>
            <h3>Sale Items</h3>
            <table class="table">
              <thead>
              <tr>
                <th>S/N</th><th>ITEM</th><th>QUANTITY</th><th>PRICE</th><th>TOTAL</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in SaleDetail.sale_detail" :key="i">
                <td>{{ i+1}}.</td><td>{{ item.item.drug }}</td><td>{{ item.itemQty }}</td><td>{{ thousandSeparator(item.unitPrice) }}</td><td><b>{{ thousandSeparator(item.unitPrice*item.itemQty) }}/=</b></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapGetters, mapActions} from "vuex";

export default {
  page: {
    title: "Sale Detail",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    // ModelListSelect
  },

  data() {
    return {
      title: "Sale Detail",
      items: [
        {
          text: "Sales Report",
          href: "#",
        },
        {
          text: "Sale Detail",
          active: true,
        },
      ],

      id:this.$route.params.id
    };
  },

  computed: {
    ...mapGetters("sales", ["SaleDetail"]),
  },

  methods: {
    ...mapActions({
      FetchSaleDetail: "sales/fetchSalesDetail",
    }),


    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

  },

  created() {
    this.FetchSaleDetail(this.id);
  },
};
</script>

<style lang="css" scoped>
</style>